
@switch (lang) {
  @default {
    <p>
      Tämä materiaali on muunnettu pdf:ksi esikatselua varten. Ota alkuperäinen materiaali käyttöön
      <a [href]="downloadUrl" download>lataamalla se tästä</a>
      .
    </p>
  }
  @case ('en') {
    <p>
      This learning resource is shown as a pdf for preview purposes. You can
      <a [href]="downloadUrl" download>download the original resources</a>
      to access it's all functionalities.
    </p>
  }
  @case ('sv') {
    <p>
      Denna lärresurs visas som pdf för förhandsgranskning. Du kan
      <a [href]="downloadUrl" download>ladda ner resursen</a>
      för att använda alla funktioner.
    </p>
  }
}

<div style="height: 80vh">
  <ng2-pdfjs-viewer [pdfSrc]="materialUrl" #officeViewer></ng2-pdfjs-viewer>
</div>
